import React from 'react';
import { BiX } from "react-icons/bi";

export const BulkActionButton = ({ icon: Icon, label, onClick, variant = 'primary', disabled = false }) => {
    const variants = {
        primary: "border-blue-200 hover:bg-blue-100 text-custom_blue",
        danger: "border-red-200 hover:bg-red-50 text-red-600",
        success: "border-green-200 hover:bg-green-50 text-green-600",
    };

    const colorClass = variants[variant] || variants.primary;

    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`flex items-center gap-2 px-3 py-1.5 bg-white border rounded-md transition-colors text-sm font-medium shadow-sm disabled:opacity-50 disabled:cursor-not-allowed ${colorClass}`}
        >
            {Icon && <Icon className="text-lg" />}
            {label}
        </button>
    );
};

const BulkActionBar = ({ selectedCount = 0, onClearSelection, children }) => {
    if (selectedCount === 0) return null;

    return (
        <div className="flex flex-col sm:flex-row items-center justify-between bg-blue-50 border border-blue-200 rounded-lg p-2 h-full animate-fadeIn gap-3 sm:gap-0">
            <div className="flex items-center gap-3 px-2">
                <div className="flex items-baseline gap-1">
                    <span className="font-bold text-custom_blue text-lg">{selectedCount}</span>
                    <span className="text-slate-600 text-sm">selecionado(s)</span>
                </div>

                {onClearSelection && (
                    <button
                        onClick={onClearSelection}
                        className="text-xs text-red-500 hover:underline flex items-center gap-1 ml-2 transition-colors"
                    >
                        <BiX size={16} /> Cancelar
                    </button>
                )}
            </div>

            <div className="flex items-center gap-2 flex-wrap justify-end">
                {children}
            </div>
        </div>
    );
};

export default BulkActionBar;